module.exports = __webpack_public_path__ + "img/pause-btn-fill.9a4a4d93.svg";